module.exports = __webpack_public_path__ + "img/rebag.72757022.png";